<template>
  <div class="categoryChildren">
    <!-- <div class="categoryChildren-title">
      <el-button type="primary"
            style="width: 100%">新增二级品类</el-button>
    </div> -->
    <div class="categoryChildren-cnt">
      <div class="categoryChildren-cnt-left">
        <div class="btn" style="padding: 0px 20px; box-sizing: border-box">
          <el-input
            v-model="cateName"
            placeholder="品类搜索"
            prefix-icon="el-icon-search"
            @change="changeTwoCate"
          ></el-input>
        </div>
        <div class="overlist">
          <div
            style="width: 100%; margin-bottom: 5px"
            v-for="item in showList"
            :key="item.id"
          >
            <el-button
              :type="firstlistindex == item.id ? 'primary' : ''"
              @click="firstlistclick(item)"
              style="width: 100%; margin-right: 10px"
              >{{ item.name }}</el-button
            >
            <el-dropdown
              placement="bottom-start"
              v-show="firstlistindex == item.id"
              @command="(event) => handleClick(event, item)"
            >
              <span class="el-dropdown-link"> ⋮ </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a">查看品类</el-dropdown-item>
                <el-dropdown-item command="b">编辑品类</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="btn">
          <el-button style="width: 82%" type="primary" @click="addChild"
            >新增二级品类</el-button
          >
        </div>
      </div>
      <div class="categoryChildren-cnt-right">
        <div style="margin-bottom: 10px">
          <el-button type="primary" @click="onHandleTag()"
            >新增三级品类</el-button
          >
          <el-button type="primary" @click="handlePublishingRule"
            >发布规则配置</el-button
          >
          <el-button type="primary" @click="handleGoodsName"
            >商品命名规则</el-button
          >
          <el-button
            type="primary"
            v-if="logistic_business_ids.includes(2)"
            @click="allclick(2)"
            >高碑店排序/显隐</el-button
          >
          <el-button
            type="primary"
            v-if="logistic_business_ids.includes(549)"
            @click="allclick(549)"
            >孝感排序/显隐</el-button
          >
          <span v-if="firstName" class="firstNameWrap"
            >所属一级品类【{{ firstName }}】</span
          >
        </div>
        <div class="auto-table-flex">
          <el-table
            :data="tableData"
            height="100%"
            v-loading="loading"
            :border="true"
            :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
          >
            <el-table-column
              type="index"
              width="100px"
              align="center"
              label="序号"
            >
            </el-table-column>
            <el-table-column prop="name" align="center" label="三级品类名称">
            </el-table-column>
            <!-- <el-table-column prop="is_show" align="center" label="是否显示隐藏">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.is_show"
                  :width="32"
                  :active-value="1"
                  active-text="显示"
                  active-color="#409EFF"
                  :inactive-value="0"
                  inactive-text="隐藏"
                  inactive-color="#C0CCDA"
                  @change="
                    changeSwitch(scope.$index, scope.row, scope.row.is_show)
                  "
                />
              </template>
            </el-table-column> -->
            <el-table-column prop="name" align="center" label="商品命名规则">
              <template slot-scope="scope">
                {{ tabname }}
              </template>
            </el-table-column>
            <el-table-column prop="name" align="center" label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="onHandleCreateall(scope.row)"
                  >商品导入</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- 二级品类 -->
    <el-dialog
      :title="childTitle"
      :visible.sync="childDialogVisible"
      v-if="childDialogVisible"
      width="85%"
      class="dialog"
      ref="refChildCategoryDialog"
      center
    >
      <div class="contents">
        <el-form
          :model="childForm"
          :rules="childRules"
          ref="childForm"
          label-width="200px"
          class="demo-ruleForm"
        >
          <el-form-item label="父级品类" prop="pid">
            <div>
              <el-select
                v-model="childForm.pid"
                clearable
                :disabled="childDisabled"
                placeholder="选择父级品类"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="品类名称" prop="name">
            <div>
              <el-input
                v-model="childForm.name"
                placeholder="请输入品类名称"
                clearable
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="运费系数(%)" prop="freight_parameter">
            <div class="inputs">
              <el-input
                v-model="childForm.freight_parameter"
                @blur="freightBlur"
                placeholder="请输入运费"
                clearable
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="服务费系数(%)" prop="purchase_parameter">
            <div class="inputs">
              <el-input
                v-model="childForm.purchase_parameter"
                @blur="purchaseBlur"
                placeholder="请输入服务费"
                clearable
              ></el-input>
            </div>
          </el-form-item>
          <!--  新增毛重/净重差 start -->
          <el-form-item label="毛重/净重差">
            <div
              v-for="(tItem, tIndex) in weight_difference_rules"
              :key="tIndex"
            >
              <div class="d-flex a-center mb-10">
                <div style="width: 300px">
                  <el-select
                    v-model="tItem.type"
                    clearable
                    placeholder="请选择"
                    @change="(e) => changeType(e, tIndex)"
                  >
                    <el-option
                      v-for="item in diffTypeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      :disabled="isTypeSelected(item.id, tIndex)"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div
                  style="margin-left: 10px; cursor: pointer"
                  @click="addOption"
                  v-if="tIndex < 1"
                >
                  <i
                    class="el-icon-circle-plus-outline"
                    size="16"
                    style="color: #13ae67"
                  ></i>
                </div>
                <div
                  style="margin-left: 10px; cursor: pointer"
                  @click="deleteOption(tItem)"
                  v-if="tIndex != 0"
                >
                  <i class="el-icon-remove-outline" style="color: #13ae67"></i>
                </div>
              </div>
              <!-- 商品毛重 start  -->
              <div v-if="tItem.type == 1">
                <div
                  v-for="(ctItem, ctIndex) in tItem.rule"
                  :key="ctIndex"
                  class="d-flex a-center mb-10"
                >
                  <div
                    style="margin-right: 5px; cursor: pointer; width: 15px"
                    @click="deleteOptionChild(tIndex, ctItem)"
                    v-if="ctIndex != 0"
                  >
                    <i
                      class="el-icon-remove-outline"
                      style="color: #13ae67"
                    ></i>
                  </div>
                  <div style="margin-right: 5px; width: 15px" v-else></div>
                  <div
                    style="margin-right: 5px; cursor: pointer; width: 15px"
                    @click="addOptionChild(tIndex)"
                  >
                    <i
                      class="el-icon-circle-plus-outline"
                      size="16"
                      style="color: #13ae67"
                    ></i>
                  </div>
                  <div class="mr10">毛重</div>
                  <div style="width: 100px" class="mr10">
                    <el-input
                      v-model="ctItem.min"
                      @blur="
                        () =>
                          (ctItem.min =
                            ctItem.min == 0
                              ? 0
                              : tool.filterUnNumber(ctItem.min, true))
                      "
                      placeholder="请输入"
                      clearable
                    ></el-input>
                  </div>
                  <div class="ml10 mr10">--</div>
                  <div style="width: 100px" class="mr10">
                    <el-input
                      v-model="ctItem.max"
                      placeholder="请输入"
                      clearable
                      @blur="
                        () =>
                          (ctItem.max = tool.filterUnNumber(ctItem.max, true))
                      "
                    ></el-input>
                  </div>
                  <div style="width: 100px" class="mr10">
                    <el-select
                      v-model="ctItem.max_type"
                      clearable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in unitTypeList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div class="mr10">商品正负差异</div>
                  <div style="width: 100px" class="mr10">
                    <el-input
                      v-model="ctItem.diff_jin"
                      placeholder="请输入"
                      clearable
                      @blur="
                        () =>
                          (ctItem.diff_jin = tool.limitDecimalInput(
                            ctItem.diff_jin
                          ))
                      "
                    ></el-input>
                  </div>
                  <div>斤</div>
                </div>
              </div>
              <!-- 商品毛重 end  -->

              <!-- 礼盒商品斤数 start  -->
              <div v-if="tItem.type == 2">
                <div
                  v-for="(ctItem, ctIndex) in tItem.rule"
                  :key="ctIndex"
                  class="d-flex a-center mb-10"
                >
                  <div
                    style="margin-right: 10px; cursor: pointer; width: 15px"
                    @click="deleteOptionChild(tIndex, ctItem)"
                    v-if="ctIndex != 0"
                  >
                    <i
                      class="el-icon-remove-outline"
                      style="color: #13ae67"
                    ></i>
                  </div>
                  <div style="margin-right: 10px; width: 15px" v-else></div>
                  <div
                    style="margin-right: 10px; cursor: pointer; width: 15px"
                    @click="addOptionChild(tIndex)"
                  >
                    <i
                      class="el-icon-circle-plus-outline"
                      size="16"
                      style="color: #13ae67"
                    ></i>
                  </div>
                  <div class="mr10">礼盒装</div>
                  <div style="width: 100px" class="mr10">
                    <el-input
                      v-model="ctItem.min"
                      placeholder="请输入"
                      clearable
                      @blur="
                        () =>
                          (ctItem.min =
                            ctItem.min == 0
                              ? 0
                              : tool.filterUnNumber(ctItem.min, true))
                      "
                    ></el-input>
                  </div>
                  <div class="ml10 mr10">--</div>
                  <div style="width: 100px" class="mr10">
                    <el-input
                      v-model="ctItem.max"
                      placeholder="请输入"
                      clearable
                      @blur="
                        () =>
                          (ctItem.max = tool.filterUnNumber(ctItem.max, true))
                      "
                    ></el-input>
                  </div>
                  <div style="width: 100px" class="mr10">
                    <el-select
                      v-model="ctItem.max_type"
                      clearable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in unitTypeList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div class="mr10">商品正负差异</div>
                  <div style="width: 100px" class="mr10">
                    <el-input
                      v-model="ctItem.diff_jin"
                      placeholder="请输入"
                      clearable
                      @blur="
                        () =>
                          (ctItem.diff_jin = tool.limitDecimalInput(
                            ctItem.diff_jin
                          ))
                      "
                    ></el-input>
                  </div>
                  <div>
                    斤,按照毛重进行报损或者品控，并且客户报损时如净重缺称
                    则直接进行赔付。
                  </div>
                </div>
              </div>
              <!-- 礼盒商品斤数 end  -->
            </div>
            <div></div>
          </el-form-item>

          <!-- 二级品类增加排序 start -->
          <el-form-item label="排序" prop="listorder">
            <el-input
              v-model="childForm.listorder"
              placeholder="请输入排序值"
              maxlength="5"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="商品详情默认图片" prop="detail_pic">
            <b-file-upload
              key="detail_pic"
              :accepts="['jpg', 'jpeg', 'png']"
              :limit="1"
              v-model="detailPicList"
            ></b-file-upload>
          </el-form-item>

          <el-form-item label="商品详情默认视频" prop="detail_video">
            <b-file-upload
              key="detail_video"
              :accepts="['mp4', 'avi', 'flv', 'mov']"
              :limit="1"
              v-model="detailVideoList"
            ></b-file-upload>
          </el-form-item>
          <!-- 二级品类增加排序 end -->

          <!-- 禁售城市仓 start -->
          <el-form-item label="禁售城市仓" prop="logistic_id">
            <el-select
              class="logistic-select_wrap"
              placeholder="选择禁售城市仓"
              :loading="loadingCityStore"
              v-model="logisticIds"
              @change="onCityStore"
              multiple
              filterable
              clearable
            >
              <el-option
                v-for="item in cityStoreList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 禁售城市仓 end -->
          <el-form-item
            label="选择招商"
            prop="buyer_id"
            v-if="childForm.id && childForm.is_audit_gao == 1"
          >
            <el-select
              v-model="childForm.buyer_id"
              clearable
              placeholder="选择选择招商"
            >
              <el-option
                v-for="item in updatecategorylist"
                :key="item.id"
                :label="item.fullname"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="高碑店集配发品是否需要审核" prop="is_audit_gao">
            <el-radio-group
              v-model="childForm.is_audit_gao"
              :disabled="is_audit_gao == 1 ? true : false"
              @change="gaochang"
            >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="孝感集配发品是否需要审核" prop="is_audit_xiao">
            <el-radio-group
              v-model="childForm.is_audit_xiao"
              :disabled="is_audit_xiao == 1 ? true : false"
            >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer" v-if="childTitle != '查看子类'">
        <el-button @click="childDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="childConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 子类标签，弹窗 start -->
    <goods-tag-dialog
      ref="refGoodsTagDialog"
      @on-change="ajaxGetCategories"
    ></goods-tag-dialog>
    <!-- 子类标签，弹窗 end -->

    <el-drawer
      title="品类排序"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <div>
        <div style="text-align: right; margin-bottom: 20px">
          <el-button type="primary" @click="submit">保存</el-button>
        </div>
        <el-table
          ref="draggableTable"
          :data="tableDatasorst"
          row-key="id"
          stripe
          @row-dragged="handleRowDragged"
          height="100%"
          :border="true"
          :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
        >
          <el-table-column type="index" width="100" align="center" label="序号">
          </el-table-column>
          <el-table-column prop="is_show" align="center" label="是否显示隐藏">
            <template slot-scope="scope">
              <el-switch
                v-if="source == 2"
                v-model="tableDatasorst[scope.$index].is_show"
                :active-value="1"
                active-color="#13AE67"
                :inactive-value="0"
                inactive-color="#C0CCDA"
                @change="handleSwitchChange(scope.row, scope.$index)"
              />
              <el-switch
                v-else
                v-model="tableDatasorst[scope.$index].is_show_xiao"
                :active-value="1"
                active-color="#13AE67"
                :inactive-value="0"
                inactive-color="#C0CCDA"
                @change="handleSwitchChange(scope.row, scope.$index)"
              />
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column
            prop="item.prop"
            align="center"
            label="操作"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <i class="el-icon-rank"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
    <!-- 商品命名规则 start -->
    <productNameRule ref="productNameRuleRef" @on-change="ajaxGetCategories" />
    <!-- 商品命名规则 end -->

    <editdataalldialog
      ref="refEditDataallDialog"
      @dialogVisibleChange="ajaxGetCategories"
    ></editdataalldialog>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import Filtersearch from "@/components/Filtersearch.vue";
import Sortable from "sortablejs";
import tool from "@/utils/tools/tool";
import {
  getCategoriesList,
  postAddCategories,
  postUpdateCategories,
  postDeleteCategories,
  getCategories,
} from "@/api/generalControl/category";
import { validInteger } from "@/utils/tools/validate";
import throttle from "lodash/throttle";
import BFileUpload from "@/components/business/BFileUpload/index.vue";
import GoodsTagDialog from "./modules/goods-tag-dialog/index.vue";
import editdataalldialog from "./edit-dataall-dialog/index.vue";
import { MEMBER_QR_CODE_CONFIG, MINI_APP_PR_CODE_PAGE } from "@/utils/enum";
import { getMiniAppQrCode } from "@/api/export";
import { downLoadFlowBlob } from "@/utils/tools/base";
import productNameRule from "./modules/product-name-rule";

export default {
  name: "categoryChildren",
  inject: ["reload"],
  components: {
    Filtersearch,
    GoodsTagDialog,
    BFileUpload,
    productNameRule,
    editdataalldialog,
  },
  data() {
    return {
      tool,
      cateName: "",
      source: 2,
      firstlist: [],
      logistic_business_ids: [],
      firstlistindex: 0,
      cidType: "", //区分果蔬非果蔬
      total: 0,
      currentPage: 0,
      loading: false,
      formData: { first_cid: "" },
      from: {
        id: "",
        name: "",
        is_audit_xiao: "", //	number	孝感是否审核
        is_audit_gao: "", //	number	高碑店是否审核
        // page: 1,
        // pageSize: 50,
      },
      tableData: [],
      currentPage: 1,
      total: 0,
      listData: [],
      tableDatasorst: [],
      loading: false,
      loadingCityStore: false, // 城市仓加载loading
      cityStoreList: [], // 城市仓列表
      detailPicList: [], // 图片列表
      detailVideoList: [], // 视频列表
      updatecategorylist: [],
      options: [],
      childForm: {
        pid: "",
        id: "",
        name: "",
        freight_parameter: 100,
        purchase_parameter: 100,
        listorder: "", // 排序值
        detail_pic: "", // 商品详情默认图片
        detail_video: "", // 商品详情默认视频
        logistic_id: "", // 禁售城市仓
        is_audit_xiao: "", //	number	孝感是否审核
        is_audit_gao: "", //	number	高碑店是否审核
        buyer_id: "", //采购id
      },
      weight_difference_rules: [
        {
          type: "",
          rule: [],
        },
      ],
      diffTypeList: [
        { id: 1, name: "商品毛重正负差异" },
        { id: 2, name: "礼盒装商品斤数正负差异" },
        // { id: 3, name: "袋装的商品无正负斤数的差异" },
      ],
      unitTypeList: [
        { id: 1, name: "斤" },
        { id: 2, name: "斤及以上" },
      ],
      is_audit_xiao: "", //	number	孝感是否审核用来判断子集是否能改
      is_audit_gao: "", //	number	高碑店是否审核用来判断子集是否能改
      logisticIds: [], // 禁售城市仓，选中集合
      tagList: [
        {
          id: 1,
          name: "水萝卜",
        },
        {
          id: 2,
          name: "西贡果",
        },
        {
          id: 3,
          name: "果多美",
        },
      ], // 二级品类下的标签
      parentId: "",
      title: "",
      tabname: "",
      childTitle: "",
      centerDialogVisible: false,
      childDialogVisible: false,
      tableVisible: false,
      drawer: false,
      childRules: {
        name: [{ required: true, message: "请输入品类名称", trigger: "blur" }],
        freight_parameter: [
          {
            type: "number",
            min: 0,
            message: "最小必须是0",
            trigger: "blur",
          },
        ],
        purchase_parameter: [
          {
            type: "number",
            min: 0,
            message: "最小必须是0",
            trigger: "blur",
          },
        ],
        purchase_parameter: [
          {
            type: "number",
            max: 100,
            message: "请输入0到100的数字",
            trigger: "blur",
          },
        ],
        buyer_id: [
          { required: true, message: "请选择招商", trigger: "change" },
        ],
        is_audit_xiao: [
          { required: true, message: "请选择孝感是否审核", trigger: "change" },
        ],
        is_audit_gao: [
          {
            required: true,
            message: "请选择高碑店是否审核",
            trigger: "change",
          },
        ],
        listorder: [
          {
            required: true,
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (value !== 0 && !value) {
                callback(new Error("请输入排序值！"));
              }
              if (validInteger(value)) {
                callback(new Error("请输入大于等于0的整数！"));
              }
              callback();
            },
          },
        ],
      },
      Filtersearchlist: [],
      productNameRuleObj: {}, // 商品命名规则对象
      showList: [],
      firstName: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    console.log(to, from, "===");
    next((vm) => {
      if (vm.$store.state.Refresh) {
        console.log("刷新", vm);
        vm.reload(); //调用app.vue的方法
      } else {
        console.log("不刷新");
      }
    });
  },
  mounted() {
    this.from.id = this.$route.query.id
      ? Number(this.$route.query.id)
      : Number(sessionStorage.getItem("categoryChildrenid"));
    this.firstName = this.$route.query.name ? this.$route.query.name : " "; // 一级品类名称
    sessionStorage.setItem("categoryChildrenid", this.from.id);
    this.hqlist();
    this.getAjaxCategoriesList();
    this.ajaxGetCityStoreList(); // 调用仓接口
  },

  methods: {
    /**
     *批量 新增
     */
    onHandleCreateall(e) {
      this.$refs.refEditDataallDialog.addData(e);
    },
    handleSwitchChange(row, index) {
      console.log(
        row,
        index,
        this.tableDatasorst,
        row.is_show,
        row.is_show == 1,
        "eee=="
      );
    },
    // 判断选项id是否已被其他tItem选中
    isTypeSelected(optionId, currentTIndex) {
      // 遍历weight_difference_rules，排除当前tItem（currentTIndex），检查是否有其他tItem的type等于optionId
      return this.weight_difference_rules.some((tItem, tIndex) => {
        // 排除当前项，且只判断有值的type（避免null/undefined干扰）
        return (
          tIndex !== currentTIndex &&
          tItem.type !== null &&
          tItem.type !== undefined &&
          tItem.type === optionId
        );
      });
    },
    /**
     * 添加毛重/净重类型
     */
    addOption() {
      if (this.weight_difference_rules.length < 2) {
        this.weight_difference_rules.push({
          type: "",
          rule: [],
        });
      }
    },
    /**
     * 添加规则
     */
    addOptionChild(index) {
      this.weight_difference_rules[index].rule.push({
        min: "",
        max: "",
        max_type: "",
        diff_jin: "",
      });
    },
    /**
     * 删除规则
     */
    deleteOptionChild(index, item) {
      var tmpIndex = this.weight_difference_rules[index].rule.indexOf(item);
      if (tmpIndex !== -1) {
        this.weight_difference_rules[index].rule.splice(tmpIndex, 1);
      }
    },
    /**
     * 删除毛重/净重差类型
     */
    deleteOption(item) {
      var index = this.weight_difference_rules.indexOf(item);
      if (index !== -1) {
        this.weight_difference_rules.splice(index, 1);
      }
    },
    // 下拉框有值 默认添加一种规则
    changeType(val, index) {
      console.log(val, index, "val==");
      if (val) {
        this.weight_difference_rules[index].rule.push({
          min: "",
          max: "",
          max_type: "",
          diff_jin: "",
        });
        this.$set(this.weight_difference_rules[index], "rule", [
          {
            min: "",
            max: "",
            max_type: "",
            diff_jin: "",
          },
        ]);
      } else {
        this.weight_difference_rules[index].rule = [];
      }
      console.log(
        this.weight_difference_rules,
        "this.weight_difference_rules=="
      );
    },
    // 搜索二级品类
    changeTwoCate() {
      console.log(this.cateName, this.listData, "cat===");
      if (this.cateName) {
        this.showList = this.fuzzySearch(this.cateName, this.listData);
      } else {
        this.showList = this.listData;
      }
      this.firstlistindex = this.showList[0] ? this.showList[0].id : 0;
      this.cidType = this.showList[0] ? this.showList[0].type : ""; // 品类类型
      this.tabname = "";
      if (
        this.showList[0] &&
        this.showList[0].product_name_rule &&
        this.showList[0].product_name_rule.length > 0
      ) {
        this.tabname = this.showList[0].product_name_rule_txt;
        this.productNameRuleObj = this.showList[0].product_name_rule;
      } else {
        this.productNameRuleObj = [];
      }
      this.tableData = this.showList[0] ? this.showList[0].tags : [];
      console.log(this.showList, "www");
    },
    // 模糊搜索二级品类
    fuzzySearch(query, list) {
      // 将查询字符串和列表项都转换为小写，以实现不区分大小写的搜索
      const lowerQuery = query.toLowerCase();
      return list.filter((item) =>
        item.name.toLowerCase().includes(lowerQuery)
      );
    },
    handleSwitchChange(row, index) {
      console.log(
        row,
        index,
        this.tableDatasorst,
        row.is_show,
        row.is_show == 1,
        "eee=="
      );
    },
    // 商品命名规则
    handleGoodsName() {
      console.log(this.productNameRuleObj, " this.productNameRuleObj==");
      this.$refs.productNameRuleRef.onInitData(
        this.productNameRuleObj && this.productNameRuleObj.length > 0
          ? this.productNameRuleObj
          : null,
        this.firstlistindex
      );
    },
    // 发布规则配置
    handlePublishingRule() {
      this.$store.commit("setRefresh", false);
      let secondNameArr = this.listData.filter(
        (item) => item.id == this.firstlistindex
      ); // 获取二级品名称
      console.log(secondNameArr, "secondNameArr==");
      let names =
        secondNameArr.length > 0
          ? `${this.firstName}-${secondNameArr[0].name}`
          : `${this.firstName}`;
      this.$router.push({
        path: "/publishRuleConfig",
        query: {
          id: this.firstlistindex,
          cidType: this.cidType,
          name: names,
        },
      });
    },
    submit() {
      let arr = [];
      if (this.source == 2) {
        this.tableDatasorst.map((el) => {
          arr.push({
            id: el.id,
            is_show: el.is_show,
          });
        });
      } else {
        this.tableDatasorst.map((el) => {
          arr.push({
            id: el.id,
            is_show: el.is_show_xiao,
          });
        });
      }
      this.$api.classification
        .categoriestagsortsave({
          tag_ids: arr,
          source: this.source,
          cid: this.firstlistindex,
        })
        .then((res) => {
          console.log(res, "获取数据");
          this.hqlistnew();
          this.drawer = false;
        });
    },

    initSortable() {
      console.log(this.$refs.draggableTable);
      const el = this.$refs.draggableTable.$el.querySelector(
        ".el-table__body-wrapper tbody"
      );
      this.sortable = Sortable.create(el, {
        onEnd: (evt) => {
          const { newIndex, oldIndex } = evt;
          const movedItem = this.tableDatasorst.splice(oldIndex, 1)[0];
          this.tableDatasorst.splice(newIndex, 0, movedItem);
        },
      });
    },
    allclick(e) {
      this.source = e;
      this.drawer = true;
      this.tableDatasorst = JSON.parse(JSON.stringify(this.tableData));
      if (e == 2) {
        this.tableDatasorst.sort((a, b) => a.sort - b.sort);
      } else {
        this.tableDatasorst.sort((a, b) => a.sort_xiao - b.sort_xiao);
      }
      console.log(this.tableDatasorst);

      this.$nextTick(() => {
        this.initSortable();
      });
    },

    handleRowDragged(newData) {
      this.tableDatasorst = newData; // 如果需要更新视图或其他操作可以在这里处理
    },

    handleClose(done) {
      this.drawer = false;
      done();
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done();
      //   })
      //   .catch(_ => {});
    },

    /**
     * 获取二级品类列表
     */
    async ajaxGetCategories() {
      this.hqlistnew();
    },
    async hqlistnew() {
      this.loading = true;
      try {
        let { data } = await getCategories(this.from);
        this.listData = data.child;
        // this.firstlistindex = data.child[0] ? data.child[0].id : 0;
        data.child.forEach((el) => {
          if (el.id == this.firstlistindex) {
            this.tableData = el.tags;
            this.tabname = "";
            if (el.product_name_rule && el.product_name_rule.length > 0) {
              this.tabname = el.product_name_rule_txt;
              this.productNameRuleObj = el.product_name_rule;
            } else {
              this.productNameRuleObj = [];
            }
            return;
          }
        });

        this.loading = false;
      } catch (error) {
        console.log("ajax getCategories err", err);
        this.loading = false;
      }
    },
    /**
     * 编辑二级品类 tag
     */
    onHandleTag() {
      // this.tagList
      const tags = this.tableData;
      const tagList = tags.map((child) => {
        return {
          id: child.id,
          name: child.name,
        };
      });
      const params = {
        cid: this.firstlistindex,
        is_show: tags?.[0]?.is_show,
        tag_list: tagList || [],
      };
      // console.log("/(ㄒoㄒ)/~~ params", params);
      this.$refs.refGoodsTagDialog.onInitData(params);
    },
    handleClick(e, item) {
      console.log(e, "111", item);
      if (e == "b") {
        this.editChild(item, false);
      } else {
        this.editChild(item, true);
      }
    },
    /**
     * 获取品类数据
     */
    async getAjaxCategoriesList() {
      // this.loading = true;
      try {
        let { data } = await getCategoriesList(this.from);
        this.options = data;
        // this.loading = false;
      } catch (err) {
        console.log("ajax getCategoriesList err", err);
      }
    },
    async hqlist() {
      this.loading = true;
      try {
        let { data } = await getCategories(this.from);
        this.listData = data.child;
        this.showList = data.child;
        this.cateName = "";
        this.firstlistindex = data.child[0] ? data.child[0].id : 0;
        this.cidType = data.child[0] ? data.child[0].type : ""; // 品类类型
        this.tabname = "";
        if (
          data.child[0].product_name_rule &&
          data.child[0].product_name_rule.length > 0
        ) {
          this.tabname = data.child[0].product_name_rule_txt;
          this.productNameRuleObj = data.child[0].product_name_rule;
        } else {
          this.productNameRuleObj = [];
        }
        this.tableData = data.child[0] ? data.child[0].tags : [];
        this.formData.first_cid = this.firstlistindex;
        this.is_audit_xiao = data.is_audit_xiao; //	number	孝感是否审核用来判断子集是否能改
        this.is_audit_gao = data.is_audit_gao; //	number	高碑店是否审核用来判断子集是否能改
        this.childForm.is_audit_xiao = data.is_audit_xiao;
        this.childForm.is_audit_gao = data.is_audit_gao;
        this.logistic_business_ids = data.logistic_business_ids;
        console.log(
          "ajax getCategories",
          data,
          data.is_audit_xiao,
          data.is_audit_gao
        );

        this.loading = false;
      } catch (error) {
        console.log("ajax getCategories err", err);
        this.loading = false;
      }
    },

    firstlistclick(e) {
      this.firstlistindex = e.id;
      this.cidType = e.type;
      this.tableData = e.tags;
      console.log(e, "11111");
      this.tabname = "";
      if (e.product_name_rule && e.product_name_rule.length > 0) {
        this.tabname = e.product_name_rule_txt;
        this.productNameRuleObj = e.product_name_rule;
      } else {
        this.productNameRuleObj = [];
      }
      // this.formData.first_cid = this.firstlistindex;
      // this.getdownconfiglist();
    },
    gaochang(e) {
      if (e == 0) {
        this.childForm.buyer_id = "";
      }
    },
    getupdatecategory(e) {
      this.$api.general.updatecategory({ category_id: e }).then((res) => {
        console.log(res, "1111111111111");
        this.updatecategorylist = res.data;
      });
    },
    /**
     * 城市仓变动
     */
    onCityStore() {
      this.childForm.logistic_id = this.logisticIds.join(",");
    },
    /**
     * 校验运费系数
     */
    freightBlur() {
      console.log(tool);
      console.log(this.childForm.freight_parameter);
      this.childForm.freight_parameter = Number(
        tool.filterUnNumber(this.childForm.freight_parameter)
      );
    },
    /**
     * 校验服务费系数
     */
    purchaseBlur() {
      this.childForm.purchase_parameter = Number(
        tool.filterUnNumber(this.childForm.purchase_parameter)
      );
    },
    /**
     * 获取城市仓列表
     */
    async ajaxGetCityStoreList() {
      this.loadingCityStore = true;
      const params = {
        page: 1,
        pageSize: 1000,
      };
      try {
        const { data } = await this.$api.Followup.logisticsselect(params);
        this.cityStoreList = data;
        console.log("ajx ajaxGetCityStoreList", data);
      } catch (err) {
        console.log("ajx ajaxGetCityStoreList err", err);
      } finally {
        this.loadingCityStore = false;
      }
    },
    /**
     * 编辑二级品类
     */
    editChild(row, show) {
      this.onInitSelectData();
      if (!show) {
        this.childTitle = "编辑子类";
      } else {
        this.childTitle = "查看子类";
      }
      let tmpRow = JSON.parse(JSON.stringify(row));

      this.childDisabled = true;
      for (let key in this.childForm) {
        this.childForm[key] = tmpRow[key];
      }
      /** 回显信息处理 */
      if (this.childForm?.logistic_id) {
        this.logisticIds = this.childForm?.logistic_id
          .split(",")
          .map((child) => Number(child));
      }
      if (this.childForm.detail_pic) {
        this.detailPicList = this.childForm.detail_pic
          .split(",")
          .map((child) => {
            return {
              name: child,
              url: child,
            };
          });
      }
      if (this.childForm.detail_video) {
        this.detailVideoList = [
          {
            name: this.childForm.detail_video,
            url: this.childForm.detail_video,
          },
        ];
      }
      this.childForm.buyer_id =
        tmpRow.buyer_id_gao != 0 ? tmpRow.buyer_id_gao : "";
      this.weight_difference_rules =
        tmpRow.weight_difference_rules &&
        tmpRow.weight_difference_rules.length > 0
          ? tmpRow.weight_difference_rules
          : [
              {
                type: "",
                rule: [],
              },
            ]; // 编辑回显毛重/净重差
      this.getupdatecategory(row.id);
      this.childDialogVisible = true;
    },
    childConfirm: throttle(function () {
      this.$refs.childForm.validate(async (valid) => {
        if (valid) {
          /** 更新图片和视频字段 */
          this.childForm.detail_pic = this.detailPicList
            .map((item) => item.url)
            .join(",");
          this.childForm.detail_video = this.detailVideoList
            .map((item) => item.url)
            .join(",");
          /** 参数重组 */
          const {
            pid,
            name,
            freight_parameter,
            purchase_parameter,
            listorder,
            detail_pic,
            detail_video,
            logistic_id,
            is_audit_gao,
            is_audit_xiao,
            buyer_id,
          } = this.childForm;
          const params = {
            pid,
            name,
            freight_parameter,
            purchase_parameter,
            listorder: Number(listorder),
            detail_pic,
            detail_video,
            logistic_id,
            is_audit_gao,
            is_audit_xiao,
            buyer_id,
          };
          if (this.weight_difference_rules.length > 0) {
            params.weight_difference_rules = this.weight_difference_rules;
          } else {
            // params.weight_difference_rules = [];
          }
          if (this.childTitle == "编辑子类") {
            params.id = this.childForm.id;
            try {
              await postUpdateCategories(params);
              this.childDialogVisible = false;
              let { data } = await getCategories({
                id: this.$route.query.id
                  ? Number(this.$route.query.id)
                  : Number(sessionStorage.getItem("categoryChildrenid")),
              });
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.listData = data.child;
              this.showList = data.child;
              this.cateName = "";
            } catch (err) {
              console.log("ajax postUpdateCategories err", err);
            }
          } else {
            try {
              await postAddCategories(params);
              this.$message({
                type: "success",
                message: "添加成功",
              });
              this.childDialogVisible = false;
              this.tableVisible = false;
              let { data } = await getCategories({
                id: this.$route.query.id
                  ? Number(this.$route.query.id)
                  : Number(sessionStorage.getItem("categoryChildrenid")),
              });
              this.listData = data.child;
              this.showList = data.child;
              this.cateName = "";
            } catch (err) {
              console.log("ajax postAddCategories err", err);
            }
          }
        }
      });
    }, 500),
    // 修改状态
    changeSwitch(index, row, state) {
      this.$api.classification
        .categoriestagchangestatus({
          id: row.id,
          is_show: state,
        })
        .then((res) => {
          if (res.code == 20000) {
            this.$message({
              message:
                state == 1 ? "该分三级品类已显示！" : "该三级品类已隐藏！",
              type: "success",
            });
          } else {
            this.$message({ message: "修改三级品类状态失败！", type: "error" });
          }
        })
        .catch((err) => {
          this.$set(this.tableData[index], "is_show", state == 1 ? 0 : 1);
        });
    },

    addChild() {
      this.childTitle = "新增子类";
      this.childForm = {
        pid: this.$route.query.id
          ? Number(this.$route.query.id)
          : Number(sessionStorage.getItem("categoryChildrenid")),
        id: "",
        name: "",
        freight_parameter: 100,
        purchase_parameter: 100,
        listorder: "",
        detail_pic: "",
        detail_video: "",
        logistic_id: "",
        is_audit_xiao: this.is_audit_xiao,
        is_audit_gao: this.is_audit_gao,
        buyer_id: "",
      };
      console.log("ajx addChild", this.childForm);
      /** 重置数据 */
      this.onInitSelectData();
      this.childDisabled = true;
      this.childDialogVisible = true;
    },
    /**
     * 初始化一些数据
     */
    onInitSelectData() {
      this.detailPicList = [];
      this.detailVideoList = [];
      this.logisticIds = [];
      this.weight_difference_rules = [
        {
          type: "",
          rule: [],
        },
      ]; // 重置毛重/净重差
    },

    /**
     * 重置表单，并刷新
     */
    onHandleRefresh() {},
    /**
     * 搜索表单
     */
    onSearch(e) {
      // this.formData = e;
      // this.formData.page = 1;
      // this.hqlist();
    },
    handleSizeChange(val) {
      //   console.log(`每页 ${val} 条`);
      // this.formData.pageSize = val;
      // this.getdownconfiglist();
    },
    handleCurrentChange(val) {
      // this.formData.page = val;
      // this.currentPage = val;
      // this.getdownconfiglist();
    },
  },
};
</script>

<style lang="scss" scoped>
.categoryChildren {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  .categoryChildren-title {
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
  }

  .categoryChildren-cnt {
    flex-grow: 1;
    overflow-y: hidden;
    display: flex;
    margin-top: 10px;

    .categoryChildren-cnt-left {
      width: 15%;
      height: 100%;
      background-color: #fff;
      margin-right: 10px;
      .btn {
        width: 100%;
        text-align: center;
      }
      .overlist {
        height: calc(100% - 100px);
        box-sizing: border-box;

        padding: 20px;
        overflow-y: auto;
        div {
          display: flex;
        }
        .el-dropdown-link {
          font-size: 30px;
          font-weight: 600;
        }
      }
    }

    .categoryChildren-cnt-right {
      width: 85%;
      height: 100%;
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;

      .auto-table-flex {
        flex-grow: 1;
        overflow-y: hidden;
        margin-bottom: 10px;
      }
    }
  }
  .firstNameWrap {
    color: #13ae67;
    font-size: 14px;
    font-weight: 500;
    margin-left: 20px;
  }
}
</style>
